import { render, staticRenderFns } from "./LotsPage.vue?vue&type=template&id=0a63bb20&scoped=true"
import script from "./LotsPage.vue?vue&type=script&lang=js"
export * from "./LotsPage.vue?vue&type=script&lang=js"
import style0 from "./LotsPage.vue?vue&type=style&index=0&id=0a63bb20&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a63bb20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a63bb20')) {
      api.createRecord('0a63bb20', component.options)
    } else {
      api.reload('0a63bb20', component.options)
    }
    module.hot.accept("./LotsPage.vue?vue&type=template&id=0a63bb20&scoped=true", function () {
      api.rerender('0a63bb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/plantNursery/lots/LotsPage.vue"
export default component.exports